import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function WarningMessage({ message }) {
  return (
    <Stack
      alignItems="start"
      direction="row"
      gap="8px"
      paddingTop="12px"
    >
      <WarningAmberIcon color="red" />
      <Text
        aria-label="Error message"
        color="red"
        size="md"
      >
        {message}
      </Text>
    </Stack>
  );
}

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired
};
